import type { CalendarViewBooking } from '../calendarView.types';

/** Estados con chip en el filtro (excluye `completed` legado: se agrupa al filtrar supervisión). */
export const CALENDAR_VIEW_STATUS_ORDER: Exclude<
  CalendarViewBooking['status'],
  'completed'
>[] = ['confirmed', 'pending_deposit', 'human_supervision', 'cancelled', 'auto_cancelled'];

export const CALENDAR_VIEW_STATUS_LABEL: Record<
  Exclude<CalendarViewBooking['status'], 'completed'>,
  string
> = {
  confirmed: 'Confirmada',
  pending_deposit: 'Pendiente de seña',
  human_supervision: 'Supervisión humana',
  cancelled: 'Cancelada',
  auto_cancelled: 'Cancelada auto.',
};

/** Estados que se pueden filtrar en la vista calendario (sin legado `completed`). */
export type CalendarViewFilterableStatus = (typeof CALENDAR_VIEW_STATUS_ORDER)[number];
